import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import IconButton from '@mui/material/IconButton';
import { RxCross1 } from "react-icons/rx";
import Typography from './Typography';
import type { DialogProps } from '@mui/material/Dialog';

interface CustomModalProps {
    open: true | false;
    close: () => boolean | void;
    children: React.ReactNode;
    title?: string;
    backDrop?: boolean;
    fullScreen?: boolean;
    size?: "xs" | "sm" | "md" | "lg" | "xl"
    headerActions?: React.ReactNode;
    disableContentScroll?: boolean;
}

const CustomModal = (props: CustomModalProps) => {
    const {
        open = false,
        close = () => null,
        children = null,
        title = "",
        backDrop = false,
        fullScreen = false,
        size = "md",
        headerActions = null,
        disableContentScroll = false,
    } = props

    const handleClose: DialogProps["onClose"] = (_, reason) => {
        if (reason === "backdropClick" && backDrop) {
            return
        } else {
            close()
        }
    };


    return (
        <React.Fragment>
            <Dialog
                fullScreen={fullScreen}
                fullWidth={true}
                onClose={handleClose}
                aria-labelledby="customized-dialog-title"
                open={open}
                maxWidth={size}
                className="custom-modal"
                sx={{
                    "& .MuiDialog-paper": {
                        maxHeight: "calc(100dvh - 32px)",
                        overflowY: disableContentScroll ? "hidden" : undefined,
                    },
                }}
            >
                <div className="flex items-center gap-4 border-b border-gray-200 px-6 py-4 dark:border-gray-700">
                    <Typography variant='title' customCSS='m-0 min-w-0 flex-1 truncate'>{title}</Typography>
                    <div className="ml-auto flex items-center gap-2">
                        {headerActions}
                        <IconButton
                            aria-label="close"
                            color='primary'
                            onClick={() => close()}
                            sx={{ color: 'text.primary' }}
                        >
                            <RxCross1 />
                        </IconButton>
                    </div>
                </div>
                <DialogContent
                    className=" p-4 bg-whitesmoke"
                    dividers
                    sx={{
                        minHeight: 0,
                        overflowY: disableContentScroll ? "hidden" : "auto",
                    }}
                >
                    {children}
                </DialogContent>
            </Dialog>
        </React.Fragment>
    );
}

export default CustomModal;
